import { memo } from 'react';
import { Row, Col, Typography } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { NO_DATA_FOUND } from 'const/translations/SalaryEmployeePage';
import Styles from './NoDataFound.module.css';

const { Paragraph } = Typography;

const propTypes = {};

export const NoRewardsDataFound = memo(() => (
  <Row type="flex" justify="center">
    <Col className={Styles.content}>
      <SearchOutlined className={Styles.icon} />
      <Paragraph className={Styles.text}>
        {NO_DATA_FOUND.TEXT_FIRST_LINE}
      </Paragraph>
    </Col>
  </Row>
));

NoRewardsDataFound.propTypes = propTypes;
